import { Button, Divider } from '@patternfly/react-core';
import React from 'react';

type SectionProps = {
  bottomDivider?: boolean;
  children?: React.ReactNode;
  description?: string;
  onClick?: () => void;
  title?: string;
  topDivider?: boolean;
};

const Section = ({
  bottomDivider = false,
  children,
  description,
  onClick,
  title,
  topDivider = false,
}: SectionProps) => (
  <>
    {topDivider && <Divider />}

    <div className="section-container">
      {title && (
        <Button
          className="section-title"
          isInline
          isDisabled={!onClick}
          onClick={onClick}
          variant="link"
        >
          {title}
        </Button>
      )}

      {description && <p className="section-description">{description}</p>}
    </div>

    {children && <div className="section-children">{children}</div>}

    {bottomDivider && <Divider />}
  </>
);

export default Section;
